<template>
  <v-dialog
    :value="show"
    scrollable
    max-width="800px"
    @input="handleInput"
  >
    <v-card>
      <v-toolbar
        flat
        dark
        dense
        color="primary"
      >
        <v-toolbar-title>{{ $t('Notifications') }}</v-toolbar-title>
        <v-spacer />
        <v-btn
          icon
          dark
          @click="$emit('hide')"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text class="pt-6">
        <v-expansion-panels
          v-if="notifications.length > 0"
          v-model="panel"
          class="mb-2"
          accordion
          tile
        >
          <v-expansion-panel
            v-for="notification in paginatedNotifications[page - 1]"
            :key="notification.id"
            @change="markNotificationSeen(notification)"
          >
            <v-expansion-panel-header>
              <div class="d-flex align-center text-truncate">
                <v-icon
                  v-if="!notification.seen"
                  small
                  color="red"
                  class="pr-2"
                >
                  mdi-alert-circle
                </v-icon>
                <span class="text-truncate d-inline-block">
                  <v-chip
                    class="mr-2"
                    label
                    outlined
                    small
                  >
                    <v-icon
                      left
                      small
                    >mdi-calendar</v-icon> {{ notification.created_at }}
                  </v-chip>
                  {{ notification.title }}
                </span>
              </div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <p class="subtitle-1">
                {{ notification.title }}
              </p>

              <!-- eslint-disable vue/no-v-html -->
              <div
                class="notification-content"
                v-html="notification.message"
              />
              <!-- eslint-enable vue/no-v-html -->
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <p
          v-if="notifications.length === 0"
          class="body-1 text-center"
        >
          {{ $t('Nothing to see here!') }}
        </p>

        <div
          v-if="paginatedNotifications.length > 1"
          class="text-center mt-4"
        >
          <v-pagination
            v-model="page"
            :length="paginatedNotifications.length"
          />
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import chunk from 'lodash/chunk';
import axios from 'axios';

const NOTIFICATIONS_PER_PAGE = 5;

export default {
  props: {
    show: {
      type: Boolean
    },
    notifications: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      page: 1,
      panel: []
    }
  },

  computed: {
    paginatedNotifications() {
      return chunk(this.notifications, NOTIFICATIONS_PER_PAGE);
    }
  },

  methods: {
    handleInput(value) {
      if (value === false) {
        this.$emit('hide');
      }
    },

    async markNotificationSeen(notification) {
      if (notification.seen) {
        return;
      }

      const url = this.route('notification-seen', { id: notification.id });

      try {
        await axios.post(url.toString());
        notification.seen = true;
      } catch(e) {
        console.log(e);
      }
    }
  }
}
</script>

<style>
  .notification-content p:last-child {
    margin-bottom: 0px !important;
  }

  .notification-content img, .notification-content iframe {
    max-width: 100%;
    height: auto;
  }

  .notification-content iframe {
    border: none;
    min-height: 320px;
  }

  .v-chip:before {
    background: transparent !important;
    color: #000 !important;
  }
</style>